"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utilities = require("../../utilities");

var Sift = {
  sift: function sift(url) {
    var script = function script() {
      var element = document.createElement('script');
      element.src = url;
      return element;
    };

    return {
      script: script
    };
  },
  initialize: function initialize(settings, uuid) {
    var sessionId = uuid;

    var _sift = window._sift = window._sift || [];

    _sift.push(['_setAccount', settings.KEY]);

    _sift.push(['_setSessionId', sessionId]);

    _sift.push(['_setUserId', '']); // tslint:disable-next-line


    var sift = this.sift(settings.URL);
    var script = sift.script();
    !(0, _utilities.doesScriptSrcUrlExist)(script) && document.body.insertBefore(script, document.body.childNodes[0]);
  },
  update: function update() {
    var _a;

    var sessionEmail = (_a = JSON.parse(window.sessionStorage.getItem('@lce/local/order') || '{}')) === null || _a === void 0 ? void 0 : _a.emailAddress;

    var _sift = window._sift = window._sift || [];

    _sift.push(['_setUserId', sessionEmail]);

    _sift.push(['_trackPageview']);
  }
};
var _default = Sift;
exports["default"] = _default;